import styled from 'styled-components';
import { CURRENT_FONT, SELECTORS, UBISOFT_BOLD_FONT, UBISOFT_FONT, UBUNTU_FONT } from '../../constants/constants';
import CONFIG from '../../config';

export const PageItemsContainer = styled.div`
    ${SELECTORS} & {
      h1,h2,h3,
      span,a,p
      {
        font-family: ${CURRENT_FONT};
        color: white;
      }
      .accordion_question { 
          font-family: ${!CONFIG.isUPC ?  UBISOFT_BOLD_FONT : UBUNTU_FONT}
      }
    }
`;
export const Container = styled.div`
  width: 90%;
  max-width: 1380px;
  display: block;
  margin: 0 auto;
`;
